export default "__VITE_ASSET__DckD_jmr__"